const unitString = (type, number) => {
	let chosenUnit = '';

	switch (type) {
		case 'volume':
			chosenUnit = '\u33a5';
			break;
		case 'area':
			chosenUnit = '\u33a1';
		default:
			break;
	}

	return typeof number === 'number' ? number + ' ' + chosenUnit : chosenUnit;
};

export default unitString;
